/**
 * Validates a discount rate value, ensuring it is a number between 0 and 1 (inclusive).
 * If the value is invalid (not a number, less than 0, or greater than 1), logs a warning and returns 0.
 *
 * @param value - The discount rate to validate.
 * @returns The validated discount rate, or 0 if invalid.
 */
export const validateDiscountRate = (value: number, fallback?: number): number => {
  if (isNaN(value) || value < 0 || value > 1) {
    console.warn(`Invalid discount rate: "${value}" — falling back to "${fallback}"`)
    return fallback ?? 0
  }
  return value
}
